<template>
  <material-card
    style="margin-top: 30px"
    scrollable
    :title="$t('components.plancreationwizard.plan_eligibility')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="rule_folder"
  >
    <v-card-text>
      <v-form v-model="valid" :disabled="disabled">
        {{ $t("components.plancreationwizard.plan_entry_rules") }}
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="eligibility.MemberEligibility.IncludeWaitingPeriod"
              :label="
                $t('components.plancreationwizard.include_waiting_period')
              "
            ></v-checkbox>
          </v-col>
          <template v-if="eligibility.MemberEligibility.IncludeWaitingPeriod">
            <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <!-- <auto-select
                :value.sync="eligibility.MemberEligibility.WaitingPeriodUnit"
                :items="options.Enums.TermTimeUnit"
                :label="$t('components.plancreationwizard.waiting_period_unit')"
                :rules="[$rules.required]"
                class="required"
                :slots="true"
                :filter="filterFunc"
              >
                <template v-slot:selection="data">
                  {{ $t("enums." + data.item) }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-content
                    v-text="$t('enums.' + data.item)"
                  ></v-list-item-content>
                </template>
              </auto-select> -->
              <trans-enum
                :value.sync="eligibility.MemberEligibility.WaitingPeriodUnit"
                :items="options.Enums.TermTimeUnit"
                :label="$t('components.plancreationwizard.waiting_period_unit')"
                :rules="[$rules.required]"
                class="required"
              ></trans-enum>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <no-autocomplete-textfield
                :value="eligibility.MemberEligibility.WaitingPeriod"
                @change="eligibility.MemberEligibility.WaitingPeriod = $event"
                :label="
                  $t('components.plancreationwizard.waiting_period_{0}', [
                    eligibility.MemberEligibility.WaitingPeriodUnit
                      ? '(' +
                        eligibility.MemberEligibility.WaitingPeriodUnit +
                        's)'
                      : '',
                  ])
                "
                class="required"
                :rules="[$rules.requiredInteger]"
              ></no-autocomplete-textfield>
            </v-col>
          </template>
        </v-row>
        <template v-if="hasDependants">
          <v-card-text>
            {{ $t("components.plancreationwizard.dependants_eligibility") }}
          </v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <no-autocomplete-textfield
                :value="eligibility.MemberEligibility.MinorMaxEligibleAge"
                @change="
                  eligibility.MemberEligibility.MinorMaxEligibleAge = $event
                "
                :label="
                  $t(
                    'components.plancreationwizard.minor_dependant_maximum_age'
                  )
                "
                class="required"
                :rules="[$rules.requiredInteger]"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <no-autocomplete-textfield
                :value="
                  eligibility.MemberEligibility.DependantStudentMaxEligibleAge
                "
                @change="
                  eligibility.MemberEligibility.DependantStudentMaxEligibleAge =
                    $event
                "
                :label="
                  $t(
                    'components.plancreationwizard.student_dependant_maximum_age'
                  )
                "
                class="required"
                :rules="[$rules.requiredInteger]"
              ></no-autocomplete-textfield>
            </v-col>
          </v-row>
        </template>
        <template v-if="generalSettings.HasEligibilityBank">
          <v-card-text>
            {{ $t("components.plancreationwizard.eligibility_bank") }}
          </v-card-text>
          <v-row>
            <v-col cols="12" sm="4" align-self-end>
              <no-autocomplete-textfield
                v-model="generalSettings.Deductible"
                :label="$t('components.claims_history.header.deductible')"
                :rules="[$rules.requiredDecimal]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col cols="12" sm="4" align-self-end>
              <no-autocomplete-textfield
                v-model="generalSettings.Maximum"
                :label="
                  $t(
                    'components.plan_builder.eligibility_hour_bank_settings.maximum'
                  )
                "
                :rules="[$rules.requiredDecimal]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
          </v-row>
        </template>
      </v-form>
      <eligibility-hour-bank-settings
        v-if="generalSettings.HasEligibilityBank"
        ref="eligibilityBankSettingsTable"
        :memberGroups="memberGroups"
        identifier="eligibilityBankSettingsTable"
        :planIdentityId="planIdentityId"
        :eligibilityHourBankSettings="eligibilityHourBankSettings"
        @update-eligibility-hour-bank-settings="$emit('update-eligibility-hour-bank-settings', $event)"
        :disabled="disabled"
        :generalSettings="generalSettings"
      ></eligibility-hour-bank-settings>
      <template v-else>
        {{
          $t("components.plancreationwizard.plan_coverage_commencement_rules")
        }}
        <plan-coverage-commencement-rules
          :planCoverageCommencementRules="planCoverageCommencementRules"
          @update-plan-coverage-commencement-rules="
            $emit('update-plan-coverage-commencement-rules', $event)
          "
          :employers="employers"
          :hasClasses="hasClasses"
          :hasDefaultCoverage="
            selectedFields.filter((o) => o.Key === 'DefaultCoverageStatus')
              .length > 0
          "
          :classesArray="classesArray"
          :memberGroups="memberGroups"
          :logicalExpressionsHeaders="logicalExpressionsHeaders"
          :logicalExpressionsFields="logicalExpressionsFields"
        />
        {{
          $t("components.plancreationwizard.member_coverage_eligibility_rules")
        }}
        <member-coverage-eligibility-rules
          :memberCoverageEligibilityRules="memberCoverageEligibilityRules"
          @update-member-coverage-eligibility-rules="
            $emit('update-member-coverage-eligibility-rules', $event)
          "
          :hasClasses="hasClasses"
          :hasDefaultCoverage="
            selectedFields.filter((o) => o.Key === 'DefaultCoverageStatus')
              .length > 0
          "
          :classesArray="classesArray"
          :memberGroups="memberGroups"
          :logicalExpressionsHeaders="memberLogicalExpressionsHeaders"
          :logicalExpressionsFields="memberLogicalExpressionsFields"
        />
      </template>
      <template v-if="generalSettings.IncludeSelfPayments">
          <v-card-text>
            {{ $t("components.plancreationwizard.self_payments") }}
          </v-card-text>
          <self-payment-settings
            :memberGroups="memberGroups"
            :planIdentityId="planIdentityId"
            :selfPaymentSettings="selfPaymentSettings"
            @update-self-payment-settings="$emit('update-self-payment-settings', $event)"
            :disabled="disabled"
            :generalSettings="generalSettings">
          </self-payment-settings>
        </template>
    </v-card-text>
  </material-card>
</template>
<script>
import AutoSelect from "@/components/AutoSelect.vue";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";
import { mapGetters } from "vuex";
import PlanCoverageCommencementRules from "@/components/PlanBuilder/PlanCoverageCommencementRules.vue";
import MemberCoverageEligibilityRules from "@/components/PlanBuilder/MemberCoverageEligibilityRules.vue";
import TransEnum from "@/components/TransEnum.vue";
import EligibilityHourBankSettings from "@/components/PlanBuilder/EligibilityHourBankSettings.vue";
import SelfPaymentSettings from "@/components/PlanBuilder/SelfPaymentSettings.vue"

export default {
  props: [
    "eligibility",
    "disabled",
    "hasDependants",
    "planCoverageCommencementRules",
    "employers",
    "hasClasses",
    "hasDefaultCoverage",
    "classesArray",
    "memberGroups",
    "logicalExpressionsHeaders",
    "logicalExpressionsFields",
    "memberCoverageEligibilityRules",
    "memberLogicalExpressionsHeaders",
    "memberLogicalExpressionsFields",
    "selectedFields",
    "eligibilityHourBankSettings",
    "generalSettings",
    "planIdentityId",
    "selfPaymentSettings"
  ],
  components: {
    AutoSelect,
    NoAutocompleteTextfield,
    PlanCoverageCommencementRules,
    MemberCoverageEligibilityRules,
    TransEnum,
    EligibilityHourBankSettings,
    SelfPaymentSettings
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  data() {
    return {
      valid: false,
    };
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
    "eligibility.MemberEligibility.IncludeWaitingPeriod": {
      handler(v) {
        if (!v) {
          delete this.eligibility.MemberEligibility.WaitingPeriodUnit;
          delete this.eligibility.MemberEligibility.WaitingPeriod;
        }
      },
    },
    hasDependants: {
      handler(v) {
        if (!v) {
          delete this.eligibility.MemberEligibility.MinorMaxEligibleAge;
          delete this.eligibility.MemberEligibility
            .DependantStudentMaxEligibleAge;
        }
      },
    },
  },
  methods: {},
};
</script>
